import { createFileRoute } from "@tanstack/react-router";
import { CopyButton } from "@theprelude/ds";
import { z } from "zod";
import AuthPage from "@/components/auth-page";

function getPKCECodeVerifier() {
  return localStorage.getItem(
    `CognitoIdentityServiceProvider.${import.meta.env.VITE_COGNITO_USER_POOL_CLI_CLIENT_ID}.oauthPKCE`,
  );
}

const searchSchema = z.object({
  code: z.string(),
});

export const Route = createFileRoute("/cli-token")({
  validateSearch: searchSchema,
  component: CLITokenPage,
});

function CLITokenPage() {
  const search = Route.useSearch();
  const pkceCodeVerifier = getPKCECodeVerifier();
  const code = `${pkceCodeVerifier}/${search.code}`;

  return (
    <AuthPage title="Authentication Code">
      <main>
        <div className="flex flex-col gap-4 pt-4">
          <p>
            Copy the following code to your CLI to authenticate with Prelude.
          </p>
          <div className="flex items-center gap-2">
            <pre className="overflow-auto whitespace-pre-wrap break-all p-2 text-sm">
              {code}
            </pre>
            <CopyButton toCopy={code} />
          </div>
        </div>
      </main>
    </AuthPage>
  );
}
